import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as chat from './types';
import { jsonEscape, toBR } from '@common/lib/common/utils';

const typeCheck = type => {
  return (
    type !== 'SYSTEM' &&
    type !== 'SYSTEM_2' &&
    type !== 'NOTICE' &&
    type !== 'JOIN' &&
    type !== 'EXIT' &&
    type !== 'ASK_FOLLOW' &&
    type !== 'ASK_ESTIMATE' &&
    type !== 'INTERNET_APPLY_NOTICE' &&
    // type !== 'INTERNET_VOUCHER_NOTICE' &&
    type !== 'INTERNET_VOUCHER_OPEN_NOTICE' &&
    type !== 'INTERNET_PROMOTION_KT2408_NOTICE' &&
    type !== 'INTERNET_PROMOTION_OPEN_KT2408_NOTICE' &&
    type !== 'MOBILE_APPLY_OPEN_NOTICE' &&
    type !== 'MOBILE_DEAL_NOTICE'
  );
};
const mutations = {
  [chat.SET_CHATROOMS](state, data) {
    // 새로운 메시지 있는 경우 contentNew 저장 [hsh - 20220113]
    // var chatMessageLeng = data.count;

    // if (chatMessageLeng > 0) {
    //   var j = 0;
    //   for (var i = 0; i < chatMessageLeng; i++) {
    //     if (
    //       data.content[i].new === true &&
    //       data.content[i].block === false &&
    //       data.content[i].leave === false
    //     ) {
    //       data.contentNew[j] = data.content[i];
    //       j++;
    //     }
    //   }
    // }

    state.chatrooms.content = data.content;
    state.chatrooms.pagination = data.pagination;
    // state.chatrooms.count = data.count;

    console.log('[chatrooms]');
    console.log(state.chatrooms);
  },
  [chat.SET_CHATROOM](state, data) {
    // 2개 이상이면 디폴트 사진은 노출을 안시킨다. (hsh)
    console.log('[SET_CHATROOM]');
    console.log(data);
    if (data.content == null) {
      if (data.store != null) {
        if (data.store.storePhotos != null) {
          var pho_splice = false;
          const phoLeng = data.store.storePhotos.length;
          if (phoLeng > 1) {
            for (var i = 0; i < phoLeng; i++) {
              //console.log(data.store.storePhotos[i].defaultPhoto);
              if (data.store.storePhotos[i].defaultPhoto == 1) {
                var i_key = i;
                pho_splice = true;
              }
            }
            if (pho_splice) {
              data.store.storePhotos.splice(i_key, 1);
            }
          }
        }
      }
    }

    state.chatroom = data;
  },
  [chat.SET_CHATROOMS_WITH](state, data) {
    state.chatrooms_with.content = data.content;
    state.chatrooms_with.count = data.count;
  },
  [chat.CHATROOMS_RESET_STATE](state) {
    state.chatrooms.content = [];
    state.chatrooms.count = 0;
  },
  [chat.CHATROOM_RESET_STATE](state) {
    state.chatroom = {};
  },
  // 로컬스토리지 저장
  [chat.SET_CHATMESSAGES_LOCALSTORAGE](state, data) {
    const { chatRoomType, uuid, messageIdx, concat } = data;
    const key = `perce-chatroom-${uuid}`;
    const localStorageData = localStorage.getItem(key);
    let newData = [];
    if (data.messages.length == 1) {
      //소켓에서 받은 경우 uuid를 제거한다.
      data.messages[0].uuid = null;
    }
    //첫번째가 1인경우
    if (data.messages.length > 0 && data.messages[0].messageIdx === 1) {
      const dt = format(
        parseISO(data.messages[0].createdAt),
        'yyyy-MM-dd HH:mm',
      );
      //data넣어준다.
      data.messages = data.messages.insertArrayAt(0, [
        {
          type: 'DATE',
          message: JSON.stringify({
            date: dt.substring(0, 10),
          }),
          messageIdx: 0.7,
          createdAt: data.messages[0].createdAt,
        },
      ]);
      if (chatRoomType === 'SYSTEM') {
        data.messages = data.messages.insertArrayAt(0, [
          {
            type: 'SYSTEM',
            message: JSON.stringify({
              text:
                '퍼스을 이용하시면서 궁금한점, 불편한점 및 건의할 점이 있으면 문의를 작성 해주세요.\n문의하신 내용에 따라 답변이 늦어질 수 있습니다.',
            }),
            messageIdx: 0.1,
            createdAt: data.messages[0].createdAt,
          },
        ]);
      } else if (chatRoomType === 'OneOnOne') {
        /*data.messages = data.messages.insertArrayAt(0, [
          {
            type: 'ASK_ESTIMATE',
            message: JSON.stringify({
              text:
                '#<#black#>## 상담하시기 전에 견적요청서를 보내셔야\n#<#black#>#더욱 빠른 상담이 가능합니다. (별첨가능)',
            }),
            messageIdx: 0.2,
            createdAt: data.messages[0].createdAt,
          },
        ]);*/
        data.messages = data.messages.insertArrayAt(0, [
          // {
          //   type: 'ASK_FOLLOW',
          //   message: JSON.stringify({
          //     text:
          //       '폰파라치 종료?!\n퍼스에서 진짜 휴대폰 가격을 만나보세요!\n#<#black#>#※ 만족한 견적을 받으셨다면 매장후기도 부탁드려요~',
          //   }),
          //   messageIdx: 0.1,
          //   createdAt: data.messages[0].createdAt,
          // },
          {
            type: 'ASK_FOLLOW',
            message: JSON.stringify({
              text:
                "퍼스에서 제공하는 '견적서, 가입신청서, 개통신청서'\n 시스템을 이용하지 않고 진행된 직거래는 분쟁 시에 \n퍼스의 도움을 받을 수 없습니다.",
            }),
            messageIdx: 0.1,
            createdAt: data.messages[0].createdAt,
          },
          // {
          //   type: 'SYSTEM_2',
          //   message: JSON.stringify({
          //     text:
          //       "상담하실 때 '요청서'를 이용하시면 더욱 편리한 상담이 가능합니다. (채팅 내 '+' 첨부버튼 클릭)",
          //   }),
          //   messageIdx: 0.8,
          //   createdAt: data.messages[0].createdAt,
          // },
          {
            type: 'SYSTEM_2',
            message: JSON.stringify({
              text:
                '매장의 상황에 따라 응답하기까지 다소 시간이 걸릴 수 있습니다.',
            }),
            messageIdx: 0.8,
            createdAt: data.messages[0].createdAt,
          },
        ]);
        // data.messages = data.messages.insertArrayAt(0, [
        //   {
        //     type: 'ASK_FOLLOW',
        //     message: JSON.stringify({
        //       text:
        //         '퍼스의 주요한 기능을 사용해보세요.\n1. 관심매장 등록 후 자동견적 요청하기 (첨부가능)\n2. 매장에게 전용 견적서를 받고서 후기 작성하기',
        //     }),
        //     messageIdx: 0.1,
        //     createdAt: data.messages[0].createdAt,
        //   },
        // ]);
        // data.messages = data.messages.insertArrayAt(0, [
        //   {
        //     type: 'ASK_FOLLOW',
        //     message: JSON.stringify({
        //       text:
        //         '#<#black#>#퍼스 알림\n\n매장의 상황에 따라 응답하기까지 다소 시간이 걸릴 수 있습니다.',
        //     }),
        //     messageIdx: 0.2,
        //     createdAt: data.messages[0].createdAt,
        //   },
        // ]);
        // data.messages = data.messages.insertArrayAt(0, [
        //   {
        //     type: 'ASK_FOLLOW',
        //     message: JSON.stringify({
        //       text:
        //         '#<#black#>#퍼스 알림\n\n상담하실때 ＇요청서＇를 이용하시면 더욱 편리한 상담이 가능합니다.\n(채팅 내＇+＇첨부버튼 클릭)',
        //     }),
        //     messageIdx: 0.3,
        //     createdAt: data.messages[0].createdAt,
        //   },
        // ]);
      }
    }
    if (localStorageData) {
      let local = JSON.parse(localStorageData);
      if (local.messages.length > 0) {
        if (
          local.messages[0].messageIdx >
          data.messages[data.messages.length - 1].messageIdx
        ) {
          //앞에
          //a.messages.unshift(data.messages);
          //newData = a.messages;
          newData = local.messages.insertArrayAt(0, data.messages);
        } else if (
          local.messages[local.messages.length - 1].messageIdx <
          data.messages[0].messageIdx
        ) {
          //뒤에
          newData = local.messages.concat(data.messages);
        } else {
          //중간
          const fi = local.messages.findIndex(
            f => f.messageIdx == data.messages[0].messageIdx,
          );
          newData = local.messages.insertArrayAt(fi, data.messages);
        }
      } else {
        newData = newData.concat(data.messages);
      }
    } else {
      newData = newData.concat(data.messages);
    }

    /*newData = Array.from(new Set(newData)).sort(
      (a, b) => a.messageIdx - b.messageIdx,
    );*/
    // 중복제거
    newData = newData
      .reduce(function(acc, current) {
        if (
          acc.findIndex(
            ({ messageIdx }) => messageIdx === current.messageIdx,
          ) === -1
        ) {
          acc.push(current);
        }
        return acc;
      }, [])
      .sort((a, b) => a.messageIdx - b.messageIdx);

    const minIdx = newData.length > 0 ? newData[0].messageIdx : 1;
    const maxIdx =
      newData.length > 0 ? newData[newData.length - 1].messageIdx : 1;
    const saveData = {
      chatRoomType,
      minIdx,
      maxIdx,
      messageIdx,
      messages: newData,
    };
    console.log('localStorage save !!!,', saveData);
    window.localStorage.setItem(key, JSON.stringify(saveData));
    console.log(data.messages);
    //return data.messages;
    state.tempNewMessages = data.messages;
  },
  // localStorage또는 서버에서 받아서 state에 구성한다.
  [chat.SET_CHATMESSAGES_BY_MESSAGE_IDX](state, data) {
    let newData = state.chatmessages.data;
    const { messages } = data;
    let { append } = data;
    let sorted = messages.sort((a, b) =>
      parseFloat(a.messageIdx) > parseFloat(b.messageIdx) ? 1 : -1,
    ); //오름차순.
    let chkAppend = false;
    let messagesMin = 0;
    let messagesMax = 0;
    console.log('newData');
    console.log(newData);
    if (newData.length > 0) {
      const sortedMax = sorted[0].messageIdx;
      const sortedMin = sorted[sorted.length - 1].messageIdx;
      const messagesFirst = newData[0];
      const messagesLast = newData[newData.length - 1];
      messagesMax = messagesLast[messagesLast.length - 1].messageIdx;
      messagesMin = messagesFirst[0].messageIdx;

      console.log(
        sorted,
        sortedMin,
        sortedMax,
        messagesFirst,
        messagesLast,
        messagesMin,
        messagesMax,
      );
      //오름차순 정렬 첫번째와 기존 메시지 마지막과 비교해서 오름차순 정렬이 크면 뒤에 붙는다.
      if (sortedMin > messagesMax) {
        chkAppend = true;
        append = true;
      }
      //오름차순 정렬 마지막과 기존 메시지 첫번째와 비교해서 기존메시지가 크면 앞에 붙는다.
      else if (sortedMax < messagesMin) {
        sorted = messages.sort((a, b) =>
          parseFloat(a.messageIdx) < parseFloat(b.messageIdx) ? 1 : -1,
        ); //내림차순
        chkAppend = true;
        append = false;
      }
    } else {
      chkAppend = true;
      append = true;

      /*sorted = messages.sort((a, b) =>
        parseFloat(a.messageIdx) > parseFloat(b.messageIdx) ? 1 : -1,
      ); //오름차순.*/
    }
    //console.log('222', sorted);
    //console.log(chkAppend, append, sorted);

    sorted.forEach(m => {
      try {
        m.message = JSON.parse(jsonEscape(m.message));
      } catch (e) {
        console.log(e, m);
      }
      const dt = format(parseISO(m.createdAt), 'yyyy-MM-dd HH:mm');
      const userId = m.userId;

      //앞이나 뒤에 붙이는 경우
      if (chkAppend) {
        //앞에
        if (!append) {
          if (newData.length > 0) {
            if (m.messageIdx < messagesMin) {
              const dt2 = format(
                parseISO(newData[0][0].createdAt),
                'yyyy-MM-dd HH:mm',
              );
              const userId2 = newData[0][0].userId;
              const type2 = newData[0][0].type;
              //날짜변경선.
              let isAddDate = false;
              if (dt.substring(0, 10) != dt2.substring(0, 10)) {
                newData.unshift([
                  {
                    type: 'DATE',
                    message: {
                      date: dt2.substring(0, 10),
                    },
                    messageIdx: newData[0][0].messageIdx,
                    createdAt: newData[0][0].createdAt,
                  },
                ]);
                isAddDate = true;
              }
              //분이 다르면 다른 그룹이다.
              //사용자가 다르면 다른그룹이다.
              //시스템메시지, JOIN, EXIT는 다른그룹이다.
              if (
                dt === dt2 &&
                userId !== null &&
                userId === userId2 &&
                typeCheck(type2) &&
                typeCheck(m.type) &&
                !isAddDate
              ) {
                //같은 그룹에 추가(앞)
                if (
                  newData[0].findIndex(
                    x => parseFloat(x.messageIdx) == parseFloat(m.messageIdx),
                  ) < 0
                ) {
                  newData[0].unshift(m);
                }
              } else {
                newData.unshift([m]);
              }
            }
          } else {
            newData.unshift([m]);
          }
        }
        // 뒤에
        else {
          if (newData.length > 0) {
            let a = newData[newData.length - 1];
            const b = newData[newData.length - 1][a.length - 1];
            const dt2 = format(parseISO(b.createdAt), 'yyyy-MM-dd HH:mm');
            const userId2 = b.userId;
            const type2 = b.type;
            //날짜변경선.
            let isAddDate = false;
            if (dt.substring(0, 10) != dt2.substring(0, 10)) {
              newData = newData.concat([
                [
                  {
                    type: 'DATE',
                    message: {
                      date: dt.substring(0, 10),
                    },
                    messageIdx: b.messageIdx,
                    createdAt: b.createdAt,
                  },
                ],
              ]);
              isAddDate = true;
            }
            //분이 다르면 다른 그룹이다.
            //사용자가 다르면 다른그룹이다.
            //시스템메시지, JOIN, EXIT는 다른그룹이다.
            if (
              dt === dt2 &&
              userId !== null &&
              userId === userId2 &&
              typeCheck(type2) &&
              typeCheck(m.type) &&
              type2 !== 'DATE' &&
              !isAddDate
            ) {
              //같은 그룹에 추가(뒤)
              a = a.concat(m);
              //중복체크
              if (
                newData[newData.length - 1].findIndex(
                  x => parseFloat(x.messageIdx) == parseFloat(m.messageIdx),
                ) < 0
              ) {
                newData[newData.length - 1] = a;
              }
            } else {
              newData = newData.concat([[m]]);
            }
          } else {
            newData = newData.concat([[m]]);
          }
        }
      } else {
        //중간에 들어가야하는 경우
        //newData.find(m => parseISO(m[0].createdAt) === dt)
        let chkFind = false;
        //console.log('newData1', newData);
        for (let i = newData.length - 1; i >= 0; i--) {
          const newDataDt = format(
            parseISO(newData[i][0].createdAt),
            'yyyy-MM-dd HH:mm',
          );
          //console.log('newDataDt', newDataDt, 'dt', dt);
          //같은 시간대
          if (newDataDt === dt) {
            //concat
            newData[i] = newData[i].concat(m);
            //중복제거.
            newData[i] = newData[i]
              .reduce(function(acc, current) {
                if (
                  acc.findIndex(
                    ({ messageIdx }) => messageIdx === current.messageIdx,
                  ) === -1
                ) {
                  acc.push(current);
                }
                return acc;
              }, [])
              .sort((a, b) =>
                parseFloat(a.messageIdx) > parseFloat(b.messageIdx) ? 1 : -1,
              ); //오름차순
            chkFind = true;
            break;
          }
        }
        //시간대가 없는 경우
        //console.log('chkFind', chkFind, dt, m);
        if (!chkFind) {
          //concat하고
          newData = newData.concat([[m]]);
          //정렬
          newData = newData.sort((a, b) =>
            parseFloat(a[0].messageIdx) > parseFloat(b[0].messageIdx) ? 1 : -1,
          ); //오름차순
        }
      }
    });
    /*if(newData.length > 0 && newData[0].length > 0 && newData[0][0].messageIdx === 1) {
      const key = `perce-chatroom-${uuid}`;
      let storageData = localStorage.getItem(key);
      const { messages: storageMessages } = storageData;
      let eIndex = storageMessages.findIndex(m => m.messageIdx === 1);
      if (eIndex >= 0) {

      }
    }*/

    console.log('newData2', newData);
    state.chatmessages.data = newData;
    return newData;
  },
  [chat.CHATMESSAGES_RESET_STATE](state) {
    state.chatmessages.isLoading = false;
    state.chatmessages.data = [];
    state.chatmessages.totalElements = 0;
  },
  //admin
  [chat.SET_CHATMESSAGES](state, chatmessages) {
    if (!chatmessages.pagination) {
      chatmessages = {
        content: chatmessages,
        pagination: {
          totalElements: chatmessages.length,
          startReverseIndex: chatmessages.length,
        },
      };
    }
    state.chatmessages.totalElements = chatmessages.pagination
      ? chatmessages.pagination.totalElements
      : chatmessages.length;
    let startIdx = chatmessages.pagination.startReverseIndex;
    // let startIdx =
    //   widhdrawUsers.pagination.startIndex +
    //   Math.min(widhdrawUsers.users.length, widhdrawUsers.pagination.pageSize);

    const newData = chatmessages.content.reduce((p, c) => {
      c.idx = startIdx--;
      c.createdAt = c.createdAt
        ? format(parseISO(c.createdAt), 'yyyy-MM-dd HH:mm')
        : c.createdAt;
      p.push(c);
      return p;
    }, []);
    state.chatmessages.data = newData;
  },
  [chat.SET_CHATMESSAGES_SYSTEM_TYPE](state, chatmessages) {
    if (!chatmessages.pagination) {
      chatmessages = {
        content: chatmessages,
        pagination: {
          totalElements: chatmessages.length,
          startReverseIndex: chatmessages.length,
        },
      };
    }
    state.chatmessages_system.totalElements = chatmessages.pagination
      ? chatmessages.pagination.totalElements
      : chatmessages.length;
    let startIdx = chatmessages.pagination.startReverseIndex;
    // let startIdx =
    //   widhdrawUsers.pagination.startIndex +
    //   Math.min(widhdrawUsers.users.length, widhdrawUsers.pagination.pageSize);

    const newData = chatmessages.content.reduce((p, c) => {
      c.idx = startIdx--;
      c.reply = c.reply ? '완료' : '대기';
      c.createdAt = c.createdAt
        ? format(parseISO(c.createdAt), 'yyyy-MM-dd HH:mm')
        : c.createdAt;
      c.replyCreatedAt = c.replyCreatedAt
        ? format(parseISO(c.replyCreatedAt), 'yyyy-MM-dd HH:mm')
        : c.replyCreatedAt;
      p.push(c);
      return p;
    }, []);
    state.chatmessages_system.data = newData;
  },
  [chat.SET_CHATMESSAGE_SYSTEM_TYPE](state, data) {
    const c = data.content;
    c.reply = c.reply ? '완료' : '대기';
    c.createdAt = c.createdAt
      ? format(parseISO(c.createdAt), 'yyyy-MM-dd HH:mm')
      : c.createdAt;
    c.replyCreatedAt = c.replyCreatedAt
      ? format(parseISO(c.replyCreatedAt), 'yyyy-MM-dd HH:mm')
      : c.replyCreatedAt;
    state.chatmessage_system = c;
  },
  [chat.CHATMESSAGES_SYSTEM_TYPE_RESET_STATE](state) {
    state.chatmessages_system.isLoading = false;
    state.chatmessages_system.data = [];
    state.chatmessages_system.totalElements = 0;
  },
  [chat.CHATMESSAGE_SYSTEM_TYPE_RESET_STATE](state) {
    state.chatmessage_system = {};
  },
  [chat.CHATROOMS_WITH_RESET_STATE](state) {
    state.chatrooms_with.content = [];
    state.chatrooms_with.count = 0;
  },
  [chat.SET_POST_PROCESSING](state, params) {
    state.post_processing = params;
  },
  [chat.SET_CHATROOM_WATCH](state, data) {
    state.chatroom_watch.messageIdx = data;
  },
};

export default mutations;
